'use strict'

export const analytics = (type, data) => {
    if (!config.features.googleAnalytics?.active) return;

    switch (type) {
        case 'option card': handleOptionCard(data); break;
        case 'unit card': handleUnitCard(data); break;
        case 'favorites': handleFavorites(data); break;
        case 'page_entrance': handlePageEntrance(data); break;
    }
}

function handleUnitCard (data) {
    gtag('event', 'card_preview', {
        'bmbyPropID': data.bmbyPropID,
        'propNum': data.propNum,
        'floor': data.floor,
        'roomsCnt': data.infoPoints.roomNum,
        'price': data.price,
        'apartmentType': data.infoPoints.modelName,
        'cardViewDomain': window.location.hostname,
        'domain': window.location.hostname
    });
}

function handleOptionCard(data) {
    gtag('event', 'card_view', {
        'bmbyPropID': data.bmbyPropID,
        'propNum': data.propNum,
        'floor': data.floorNum,
        'roomsCnt': data.roomNum,
        'cardViewDomain': window.location.hostname,
        'price': data.salePrice,
        'apartmentType': data.modelName,
        'domain': window.location.hostname
    });
}

function handleFavorites(data) {
    if (!data.storageData) {
        gtag('event', 'favorite_added', {
            'addFavoritesBmbyPropID': data.crmDataOfFlat.bmbyPropID,
            'bmbyPropID': data.crmDataOfFlat.bmbyPropID,
            'addFavoritesPropNum': data.crmDataOfFlat.propNum,
            'addFavoritesCount': 1,
            'propNum': data.crmDataOfFlat.propNum,
            'floor': data.crmDataOfFlat.floorNum,
            'roomsCnt': data.crmDataOfFlat.roomNum,
            'price': data.crmDataOfFlat.salePrice,
            'apartmentType': data.crmDataOfFlat.modelName,
            'domain': window.location.hostname
        });

        return;
    }

    gtag('event', 'favorite_removed', {
        'removeFavoritesBmbyPropID': data.crmDataOfFlat.bmbyPropID,
        'bmbyPropID': data.crmDataOfFlat.bmbyPropID,
        'removeFavoritesPropNum': data.crmDataOfFlat.propNum,
        'removeFavoritesCount': 1,
        'propNum': data.crmDataOfFlat.propNum,
        'floor': data.crmDataOfFlat.floorNum,
        'roomsCnt': data.crmDataOfFlat.roomNum,
        'price': data.crmDataOfFlat.salePrice,
        'apartmentType': data.crmDataOfFlat.modelName,
        'domain': window.location.hostname
    });
}


function handlePageEntrance (data) {
    gtag('event', 'page_entrance', {
        'page': data,
        'domain': window.location.hostname
    });
}
